module.exports = __webpack_public_path__ + "img/low-fat-potato-latkes.c21f4cda.jpg";